import ProjectList from './components/ProjectList/ProjectList.jsx';
import Header from './components/Header/Header';


function App() {
  return (
    <div className="App">
      <Header />
      <ProjectList />
    </div>
  );
}

export default App;
